import { Tooltip } from '@mui/material'
import { Sparkles } from 'lucide-react'


export function AIGeneratedIndicator() {
  return (
    <Tooltip title="This application data is generated by AI">
      <div className="fixed bottom-4 left-4 z-50 flex items-center gap-2 bg-gradient-to-r from-[#FF5533] to-[#FF7A5C] text-white px-3 py-2 rounded-full shadow-lg cursor-pointer hover:shadow-xl transition-all duration-300 border border-white">
        <Sparkles className="h-4 w-4" />
        <span className="text-xs font-medium">AI-Generated</span>
      </div>
    </Tooltip>
  )
}
